<template>
    <div>
        <div class="single--item mt-2 ml-2">
            <div class="row">
                <div class="col-3">
                    <div class="single--item-info">
                        <h6 class="text-secondary-heading ml-2">{{ __('views.Table.people_index.Responsabile') }}</h6>
                    </div>
                </div>
                <div class="col-3">
                    <div class="single--item-info">
                        <h6 class="text-secondary-heading ml-2">{{ __('views.trainingRequestCourse.started_at') }}</h6>
                    </div>
                </div>
                <div class="col-3">
                    <div class="single--item-info">
                        <h6 class="text-secondary-heading ml-2">{{ __('views.trainingRequestCourse.ended_at') }}</h6>
                    </div>
                </div>
                <div class="col-3">
                    <div class="single--item-button"></div>
                    <h6 class="text-secondary-heading">{{ __('views.trainingRequests.actions') }}</h6>
                </div>
            </div>
        </div>
        <div class="single--item mb-2 ml-2">
            <form>
                <div class="row" v-for="(row, index) in responsible_list" style="padding: 5px">
                    <div class="col-3">
                        <div class="single--item-info form-group">
                            <select v-model="row.responsible_id" class="form-control" style="width: 100%;"
                                @change="updateRow($event, row, 'responsible_person_id')">
                                <option disabled value="">{{ __('misc.select') }}</option>
                                <option v-for="(resp, index) in people_list" :value="resp.id"> {{ resp.fullName }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="single--item-info form-group">
                            <input class="form-control" v-model="row.started_at" type="date"
                                @change="updateRow($event, row, 'started_at')">
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="single--item-info form-group">
                            <input class="form-control" v-model="row.ended_at" type="date"
                                @change="updateRow($event, row, 'ended_at')">
                        </div>
                    </div>
                    <div class="col-3">
                        <div v-if="can_delete" class="single--item-button form-group">
                            <button type="button"
                                class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1"
                                @click="rmRowResponsible(row.id)">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div v-if="can_write">
            <div class="mt-4 mb-4 ml-2">
                <h6 class="text-primary">{{ __('forms.PeopleRoles.new_responsible') }}</h6>
                <h6>{{ __('forms.PeopleRoles.responsibles_instructions') }}</h6>
            </div>
            <div class="single--item mt-2 ml-2">
                <div class="row">
                    <div class="col-3">
                        <div class="single--item-info ">
                            <h6 class="text-secondary-heading ml-2">{{ __('views.Table.people_index.Responsabile') }}</h6>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="single--item-info">
                            <h6 class="text-secondary-heading ml-2">{{ __('views.trainingRequestCourse.started_at') }}</h6>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="single--item-info">
                            <h6 class="text-secondary-heading ml-2">{{ __('views.trainingRequestCourse.ended_at') }}</h6>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="single--item-button"></div>
                        <h6 class="text-secondary-heading">{{ __('views.trainingRequests.actions') }}</h6>
                    </div>
                </div>
            </div>
            <div class="single--item mb-2 ml-2">
                <form>
                    <div class="row" style="padding: 5px">
                        <div class="col-3">
                            <div class="single--item-info form-group">
                                <select v-model="new_responsible" class="form-control" style="width: 100%;">
                                    <option disabled value="">{{ __('misc.select') }}</option>
                                    <option v-for="(resp, index) in people_list" :value="resp.id"> {{ resp.fullName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="single--item-info form-group">
                                <input class="form-control" v-model="new_start" type="date">
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="single--item-info form-group">
                                <input class="form-control" v-model="new_end" type="date">
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="single--item-info form-group">
                                <a href="#" @click="addResponsible()"
                                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1"><i
                                        class="fas fa-plus"></i></a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        rmRowResponsible(row_id) {
            axios.delete("/people-responsible/" + row_id + "/person-responsible").then((response) => {
                this.refreshTable();
            });
        },
        updateRow(event, row, field) {
            row[field] = event.target.value;
            let datas = {
                "responsible_person_id": row.responsible_id,
                "started_at": row.started_at,
                "ended_at": row.ended_at,
            };
            axios.put("/people-responsible/" + row.id + "/person-responsible/update", datas).then((response) => {
                this.refreshTable();
            });
        },
        addResponsible() {
            if (this.new_responsible === null || this.new_start === null) {
                alert("Responsabile o data inizio non possono essere vuote");
                return;
            }
            let datas = {
                "responsible_person_id": this.new_responsible,
                "started_at": this.new_start,
                "ended_at": this.new_end,
            };
            axios.post("/people-responsible/" + this.person_role_id + "/person-role/store", datas).then((response) => {
                this.refreshTable();
            });
        },
        refreshTable() {
            axios.get(this.api_url)
                .then((response) => {
                    this.responsible_list = response.data;
                    console.log("downloaded");
                });
        }
    },
    mounted() {
        this.refreshTable();
    },
    data() {
        return {
            new_responsible: null,
            new_start: null,
            new_end: null,
            responsible_list: [],
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    props: {
        person_role_id: {
            type: Number,
            required: true
        },
        api_url: {
            type: String,
            required: true
        },
        people_list: {
            type: Array,
            required: true
        },
        can_write: {
            type: Boolean,
            default: false,
            required: true
        },
        can_delete: {
            type: Boolean,
            default: false,
            required: true
        },
    },
}
</script>

